import UserInformationEdit from './UserInformationEdit';

export default UserInformationEdit;
